import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import { selectUserInformations } from "../../features/authSlice";
import { API } from "../../shared/api/Api";
import { showToast } from "../../utils/utils";
import StudentTable from "../../components/Tables/StudentTable";

const DEBOUNCE_DELAY = 700;

const StudentPage = () => {
  const [reFetchData, setReFetchData] = useState(false);
  const [students, setStudents] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [loader, setLoader] = useState(true);
  const [orderBy, setOrderBy] = useState("created_at");
  const [orderDir, setOrderDir] = useState("DESC");

  const params = useParams();
  const user = useSelector(selectUserInformations);

  const fetchStudents = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API.Students.app_students_all}`, {
        params: {
          page: currentPage,
          search: debouncedSearch,
          orderBy: orderBy,
          orderDir: orderDir,
        },
        headers: { Authorization: `Bearer ${user.token}` },
      });
      if (data.status === 200 && data.errorCode === 0) {
        // Assuming similar structure
        setStudents(data.data.items);
        setCurrentPage(data.data.current_page);
        setTotalPages(data.data.last_page);
      } else {
        showToast("Error", "Failed to fetch students", "error");
      }
    } catch (error) {
      showToast(
        "Error",
        error.response?.data?.message ||
          "An error occurred while fetching students",
        "error"
      );
    }
  }, [currentPage, debouncedSearch, user.token, orderBy, orderDir]);

  const handleSort = (column, direction) => {
    setOrderBy(column);
    setOrderDir(direction);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
      setCurrentPage(1);
    }, DEBOUNCE_DELAY);

    return () => clearTimeout(handler);
  }, [search]);

  useEffect(() => {
    const fetchData = async () => {
      setLoader(true);
      try {
        setStudents([]);
        await fetchStudents();
      } catch (error) {
        showToast("Error", error.message || "An error occurred", "error");
      } finally {
        setLoader(false);
        setReFetchData(false);
      }
    };
    fetchData();
  }, [fetchStudents, reFetchData]);

  return (
    <div className="min-h-screen p-2 sl:pt-0 sm:p-2 md:p-4 sl:p-6">
      <StudentTable
        students={students}
        currentPage={currentPage}
        totalPages={totalPages}
        onSearchChange={setSearch}
        onPageChange={setCurrentPage}
        loader={loader}
        setReFetchData={setReFetchData}
        onSort={handleSort}
        currentOrderBy={orderBy}
        currentOrderDir={orderDir}
      />
    </div>
  );
};
export default StudentPage;
